// SNKRR BAR welcome/exit popup - TEMPORARILY DISABLED 2026-07-17 for the Back to Skool 2k26 sale.
// Replaced by the Hoppy Popups 'Back to Skool Locker' spin wheel to avoid two popups colliding.
// This file is intentionally a no-op. To RE-ENABLE, restore the original assets/snkrr-popups.js
// from another theme (e.g. #176494248100) or the ~/.audit/snkrrbar/theme-work/ backup.
(function(){ 'use strict'; /* disabled for sale */ })();
